import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";

export const Counter = ({
  value,
  decimals = 0,
  prefix = "",
  suffix = "",
  label,
  sub,
  dark = false,
  testId,
}) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [display, setDisplay] = useState((0).toFixed(decimals));

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2.2,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(v.toFixed(decimals)),
    });
    return () => controls.stop();
  }, [inView, value, decimals]);

  return (
    <div ref={ref} data-testid={testId} className="flex flex-col gap-3">
      <div
        className={`font-mono text-5xl sm:text-6xl font-medium tracking-tight ${
          dark ? "text-cream" : "text-forest"
        }`}
      >
        {prefix && <span className={`text-2xl align-top ${dark ? "text-sage" : "text-emerald"}`}>{prefix}</span>}
        {display}
        {suffix && <span className={`text-2xl ${dark ? "text-sage" : "text-emerald"}`}>{suffix}</span>}
      </div>
      <p className={`text-sm leading-relaxed ${dark ? "text-cream/80" : "text-moss"}`}>{label}</p>
      {sub && (
        <p className={`font-mono text-[10px] uppercase tracking-[0.2em] ${dark ? "text-sage/70" : "text-fog"}`}>
          {sub}
        </p>
      )}
    </div>
  );
};
